<template>
    <div
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                JADWAL SERVIS SARANA {{ sarana[services.kodeUnit] }}
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                >
                    <div class="mb-3">
                        <label class="form-label" for="nomorLambung"
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <select
                            class="form-control"
                            id="nomorLambung"
                            name="kodeUnit"
                            placeholder="NOMOR LAMBUNG"
                            v-model="services.kodeUnit"
                            required="required"
                            disabled="disabled"
                        >

                        <option value="" selected="selected">-- Pilih --</option>
                        <option  v-for="(i,k) in sarana" :value="k"> {{ i }}</option>
                    </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="merkType">MEREK - Type</label>
                        <input
                            type="text"
                            class="form-control"
                            id="merkType"
                            v-model="services.merkType"
                            placeholder="MEREK - Type"
                            required="required"
                            disabled="disabled"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmMeter">Kilometer Unit</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kilometerUnit"
                            v-model="services.kilometerUnit"
                            placeholder="Kilometer Unit"
                            disabled="disabled"
                            required="required"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmBerkala">Kilometer Serivce Berkala</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kmBerkala"
                            v-model="services.kilometerBerkala"
                            placeholder="Kilometer Serivce Berkala"
                            required="required"
                            disabled="disabled"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="kmGeneral">Kilometer Serivce General</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kmGeneral"
                            v-model="services.kilometerGeneral"
                            placeholder="Kilometer Serivce General"
                            required="required"
                            disabled="disabled"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="catatanService">Catatan Service Saat Ini</label>
                        <textarea
                            type="text"
                            class="form-control"
                            id="catatanService"
                            v-model="services.catatan"
                            placeholder="Catatan Service Saat Ini"
                            rows="5"
                            disabled="disabled"
                            required="required"
                        ></textarea>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="tanggal"
                            >Tanggal</label
                        >
                        <input
                            type="date"
                            class="form-control"
                            id="tanggal"
                            v-model="services.tanggal"
                            required="required"
                            disabled="disabled"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="jam">Waktu</label>
                        <input
                            type="time"
                            class="form-control"
                            id="jam"
                            v-model="services.jam"
                            placeholder="Waktu"
                            step="2"
                            required="required"
                            disabled="disabled"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="Pengemudi">Pengemudi</label>
                        <input
                            type="text"
                            class="form-control"
                            id="driver"
                            v-model="services.driver"
                            placeholder="Pengemudi"
                            step="2"
                            required="required"
                            disabled="disabled"
                        />
                    </div>

                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        @click="closePage"
                    >
                        Close
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
    mounted() {
        if(this.servis!="")
            this.services = JSON.parse(this.servis)

        this.getSarana();
    },
    data() {
        return {
            moment:moment,
            services: {},
            sarana: [],
            vehicle : [],
            users:{},
        };
    },
    props: ["tokens", "url_action","servis"],
    methods: {
        getSarana() {
            this.initDatas();
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        var vhc = {};
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                });
        },
       
        initDatas() {
        },
        closePage(){
            window.close()
        },
        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString();
        }
    },
    expose: ["initDatas", "getByIds", "focusInputs"],
};
</script>